/* Pilates&Me — landing kit (V2) : CTA, onglets de zones, vidéos, apparitions, son des stories */
(function () {
  if (window.pmLpInit) return;
  window.pmLpInit = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function scrollToEl(el, block) {
    if (el) el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: block || 'start' });
  }

  // Zones : sélection d'un onglet (clic, lien « C'est mon cas », ?zone=, #zone-)
  function selectZone(root, handle) {
    var ok = false;
    root.querySelectorAll('[data-zone-tab]').forEach(function (t) {
      var on = t.getAttribute('data-zone-tab') === handle;
      if (on) ok = true;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
    });
    if (!ok) return false;
    root.querySelectorAll('[data-zone-panel]').forEach(function (p) {
      var on = p.getAttribute('data-zone-panel') === handle;
      p.hidden = !on;
      p.querySelectorAll('video').forEach(function (v) { if (!on) v.pause(); });
      if (on) p.querySelectorAll('[data-pm-reveal]').forEach(function (r) { r.classList.add('is-in'); });
    });
    return true;
  }

  function goToZone(handle) {
    var root = document.querySelector('[data-pm-lp-zones]');
    if (root && selectZone(root, handle)) scrollToEl(root);
  }

  document.addEventListener('click', function (e) {
    var cta = e.target.closest('[data-pm-lp-cta]');
    if (cta) {
      // « Demander un devis » : déclenche le bouton de devis existant du bloc produit (même panier devis, même formulaire)
      if (cta.getAttribute('data-pm-lp-cta') === 'quote') {
        var quote = document.querySelector('[id^="shopify-section-"][id$="__main"] button[data-pmb-quote-add]');
        if (quote) { e.preventDefault(); quote.click(); return; }
      }
      var form = document.querySelector('[id^="shopify-section-"][id$="__main"] form[action*="/cart/add"]');
      if (form) { e.preventDefault(); scrollToEl(form, 'center'); }
      return;
    }
    var link = e.target.closest('[data-pm-zone-link]');
    if (link && document.querySelector('[data-pm-lp-zones]')) {
      e.preventDefault();
      goToZone(link.getAttribute('data-pm-zone-link'));
      return;
    }
    var tab = e.target.closest('[data-zone-tab]');
    if (tab) {
      var root = tab.closest('[data-pm-lp-zones]');
      selectZone(root, tab.getAttribute('data-zone-tab'));
      tab.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
      return;
    }
    var snd = e.target.closest('[data-pm-sound]');
    if (snd) {
      var v = snd.closest('[data-pm-story]').querySelector('video');
      if (!v) return;
      var turnOn = v.muted;
      document.querySelectorAll('[data-pm-story] video').forEach(function (o) { o.muted = true; o.closest('[data-pm-story]').classList.remove('is-sound'); });
      v.muted = !turnOn;
      if (turnOn) { v.currentTime = 0; v.play().catch(function () {}); snd.closest('[data-pm-story]').classList.add('is-sound'); }
    }
  });

  // Avant / après : le curseur (input range invisible posé sur les photos) déplace la séparation
  document.addEventListener('input', function (e) {
    if (!e.target.classList || !e.target.classList.contains('ba-range')) return;
    var frame = e.target.closest('[data-pm-ba]');
    if (frame) frame.style.setProperty('--pos', e.target.value + '%');
  });

  // Onglets au clavier (flèches gauche/droite)
  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest && e.target.closest('[data-zone-tab]');
    if (!tab || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    var tabs = Array.prototype.slice.call(tab.parentNode.querySelectorAll('[data-zone-tab]'));
    var next = tabs[(tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
    next.focus(); next.click();
  });

  // Vidéos : lecture quand visibles. Apparitions au scroll.
  var videoIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var v = en.target;
      if (en.isIntersecting && !v.closest('[hidden]')) { var p = v.play(); if (p) p.catch(function () {}); }
      else v.pause();
    });
  }, { threshold: 0.3 }) : null;
  var revealIO = 'IntersectionObserver' in window && !reduce ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); revealIO.unobserve(en.target); } });
  }, { threshold: 0, rootMargin: '0px 0px -8% 0px' }) : null;

  // Filet de sécurité : tout élément dont le haut est passé dans l'écran est affiché
  // (défilement rapide, carrousels horizontaux dont les cartes sont hors champ latéralement).
  var pending = false;
  function revealPassed() {
    pending = false;
    document.querySelectorAll('.pm-lp [data-pm-reveal]:not(.is-in)').forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight * 0.92) el.classList.add('is-in');
    });
  }
  window.addEventListener('scroll', function () { if (!pending) { pending = true; requestAnimationFrame(revealPassed); } }, { passive: true });

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('.pm-lp-media video').forEach(function (v) { if (videoIO) videoIO.observe(v); });
    scope.querySelectorAll('.pm-lp [data-pm-reveal]').forEach(function (el) {
      if (revealIO) revealIO.observe(el); else el.classList.add('is-in');
    });
    revealPassed();
    var root = scope.querySelector('[data-pm-lp-zones]');
    if (root && scope === document) {
      var q = new URLSearchParams(location.search).get('zone');
      var h = location.hash.indexOf('#zone-') === 0 ? location.hash.slice(6) : null;
      if ((q || h) && selectZone(root, (q || h).toLowerCase())) setTimeout(function () { scrollToEl(root); }, 300);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
